import { render, staticRenderFns } from "./MemoIcon.vue?vue&type=template&id=d707e7ec&"
import script from "./MemoIcon.vue?vue&type=script&lang=ts&"
export * from "./MemoIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports